/* eslint-disable */


/**
 * Create styles for `<OrdersDashboard />`
 * @param {Styles} styles The result of `createStyles`
 * @property {MuiTheme} theme The [`material-ui`](https://material-ui.com/) [theme](https://material-ui.com/customization/default-theme/)
 * @returns The `<OrdersDashboard />` styles
 */
const ordersDashboardStyles = ({ theme }) => ({
  alwaysCenter: {
    display: `block`,
    margin: `0 auto`,
    overflow: `auto`,
    [theme.breakpoints.up(`md`)]: {
      paddingLeft: 0,
    },
  },
  content: {
    display: `flex`,
    flexGrow: 1,
    margin: `0 auto 0 0`,
    position: `relative`,
  },
  inPageHeaderContainer: {
    paddingLeft: theme.spacing(1) * 3,
    [theme.breakpoints.down(`xs`)]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  accountSwitcher: {
    paddingLeft: theme.spacing(1) * 3,
  },
  loader: {
    height: 2,
  },
  main: {
    [theme.breakpoints.down(`xs`)]: {
      width: `100vw`,
    },
    width: `100%`,
  },
  orderListContainer: {
    [`-webkit-overflow-scrolling`]: `touch`,
    // height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`,
    height: `100%`,
  },
  paddingDense: {
    padding: theme.spacing(1) * 1,
  },
  paddingNone: {
    padding: 0,
  },
  paddingNormal: {
    padding: theme.spacing(1) * 3,
  },
  pageHeaderContainer: {
    padding: `${theme.spacing(1) * 2 + 5}px ${theme.spacing(1) * 2}px`,
    backgroundColor: `#fff`,
    flexWrap: `nowrap`,
  },
  pageHeaderContainerSmall: {
    height: 0,
    padding: 0,
    position: `relative`,
    top: theme.spacing(1) * 4,
    overflow: `visible`,
    zIndex: 999,
    right: 18,
  },
  refineHeader: {
    display: `flex`,
    padding: `${theme.spacing(1) * 2}px`,
  },
  folderIcon: {
    color: theme.boralcolorspalette.zambezi[600],
  },
  chipLabel: {
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    display: `block`,
    maxWidth: 182,
  },
  projectSpinner: {
    height: theme.spacing(1) * 13,
  },
  root: {
    height: `100%`,
    backgroundColor: `#fff`,
    [theme.breakpoints.down(`xs`)]: {
      width: `100vw`,
    },
  },
  sidebar: {
    display: `flex`,
  },
  stage: {
    display: `flex`,
    flexDirection: `row`,
    flexGrow: 1,
    minHeight: 0,
  },
  refreshButton: {
    marginRight: theme.spacing(2),
  },
});

export default ordersDashboardStyles;
